import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useI18n } from "@/i18n/I18nProvider";
import { getContactUaeText } from "../../../locales/contact-uae";

const Contact_Video = dynamic(() => import("@/components/contact_video"));

const VIDEO_RATIO = "58 / 47";

export default function SecondSection() {
  const { t, locale } = useI18n();
  const contactUaeText = getContactUaeText(locale);


  return (
    <Box
      className="horizontal-safe-padding vertical-safe-padding"
      sx={{ backgroundColor: "#FAFAFA" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          justifyContent: "space-between",
          gap: {
            xs: 4,
            lg: 10,
          },
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: "100%",
            flex: { md: "1 1 550px" },
            maxWidth: { xs: '85%', md: "620px" },
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              aspectRatio: VIDEO_RATIO,
              minHeight: { xs: 260, sm: 320, md: 360 },
              borderRadius: "16px",
              overflow: "hidden",
              bgcolor: "#000",

              "& iframe": {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                border: 0,
                display: "block",
              },

              "& video": {
                width: "100%",
                height: "100%",
                objectFit: "cover", 
                display: "block",
              },
            }}
          >
            <Contact_Video />
          </Box>
        </Box>

        {/* TEXT SECTION */}
        <Box sx={{ flex: { md: "1 1 520px" }, minWidth: 0 }}>
          <Box sx={{ maxWidth: { sm: locale === "en" ? "650px" : "500px" } }}>
            <Box sx={{ position: "relative", display: "inline-block" }}>
              <Box
                component="h3"
                sx={{
                  color: "#2D317F",
                  fontSize: { xs: "20px", sm: "32px" },
                  fontWeight: "bold",
                  m: 0,
                }}
              >
                {contactUaeText.second_section.title}
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  width: "100%",
                  mt: "3px",
                  height: "6px",
                  transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
                }}
                component="img"
                alt="image line"
                src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/line-main.webp"
              />
            </Box>
          </Box>

          <Box
            sx={{
              fontWeight: 300,
              fontSize: "16px",
              color: "#404456",
              width: { sm: locale === "en" ? "650px" : "500px" },
              mt: 4,
            }}
          >
            {contactUaeText.second_section.description}
          </Box>

          <List
            sx={{
              listStyleType: "disc",
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              alignContent: "space-around",
              justifyContent: "flex-start",
              width: { sm: "320px" },
              height: { sm: "470px" },
              padding: "24px 16px 8px 16px",
              gap: "24px",
            }}
          >
            {contactUaeText.second_section.list.map((item, index) => (
              <Typography
                key={index}
                component="li"
                sx={{
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "24px",
                  paddingLeft: locale === "en" ? 0 : 10,
                  paddingRight: locale === "en" ? 10 : 0,
                  color: "#2d317f",
                  listStyle: "disc",
                }}
              >
                <Link
                  href={item.url}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    textDecoration: "underline",
                  }}
                >
                  {item.name}
                </Link>
              </Typography>
            ))}
          </List>
        </Box>
      </Box>
    </Box>
  );
}
